import styled from "styled-components";

const ProductListContainer = styled.div`
`;

export default ProductListContainer;